import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { doCheckToken, doSetPassword } from '../reducers/actions'
import { Container, Panel, FieldSet, FormPanel, PasswordField, Spacer, Label, Button } from '@sencha/ext-modern'

import * as utility from '../public'
import colors from '../components/colors'
import Logo from './Logo'
import Supplier from './Supplier'

const panelProps = {
  height: "100%",
  margin: '0 0 40 0'
}

class SetPassword extends React.Component {
  state = {
    submitting: false,
    formData: {
      newPassword: '',
      checkPassword: '',
    },
    setSuccess: null,
    errorMessage: null,
  }

  handleBack = () => {
    this.props.history.push('/')
  }

  handleSubmit = () => {
    const { submitting, formData: { newPassword, checkPassword }, errorMessage } = this.state
    if (submitting || errorMessage)
      return

    if (!newPassword || !checkPassword) {
      this.setState({
        errorMessage: '请输入重置密码'
      })
      return
    }
    const { match: { params: { token } }, doSetPassword } = this.props
    doSetPassword({
      token, password: newPassword,
      onRequest: () => {
        this.setState({
          submitting: true,
          setSuccess: null
        })
      },
      onEnd: ({ errorMessage }) => {
        this.setState({
          submitting: false,
          errorMessage,
          setSuccess: errorMessage ? false : true,
        })
      },
    })
  }

  handleInput = (obj, value) => {
    const { formData } = this.state
    const name = obj.getName()
    const newFormData = { [name]: value }
    const { newPassword, checkPassword } = { ...formData, ...newFormData }
    const errorMessage = (name === "newPassword" && !utility.validatePassword(newPassword) || name === "checkPassword" && !utility.validatePassword(checkPassword)) ? `密码不符合规范` :
      (checkPassword === newPassword ? "" : "两次密码输入不一致")
    this.setState({ formData: { ...formData, ...newFormData }, errorMessage })
  }

  handleKeyPress = () => {
    this.handleSubmit()
  }

  componentWillMount() {
    const { match: { params: { token } }, doCheckToken } = this.props
    doCheckToken({
      token,
      onEnd: ({ userName, errorMessage }) => {
        if (errorMessage) {
          this.setState({ errorMessage })
        } else {
          this.setState({ userName })
        }
      },
    })
  }

  render() {
    const { errorMessage, submitting, setSuccess } = this.state
    return (
      <Panel shadow layout="fit" {...panelProps} >
        <Container layout={{ type: 'hbox', align: 'top', pack: "center" }} style={colors.card.grey} padding={Ext.os.is.Phone ? "20% 0 0 0" : "150 0 0 0"}>
          <FormPanel shadow>
            <Spacer height="10" />
            <Logo title={setSuccess ? "重置成功" : "重置密码"} />
            <Spacer height="10" />
            <FieldSet title="" width={Ext.os.is.Phone ? "280" : "320"}>
              <Label html={setSuccess ? "密码重置成功！" : "请设置您的新密码，密码长度应不少于6位，并同时包括大写字符、小写字符和数字。"} />
              {!setSuccess && <PasswordField label="新密码"
                name="newPassword"
                labelAlign="top"
                required
                placeholder="请输入新密码"
                requiredMessage="请输入新密码"
                onAction={this.handleKeyPress}
                onChange={this.handleInput} />}
              {!setSuccess && <PasswordField label="重复新密码"
                name="checkPassword"
                labelAlign="top"
                required
                placeholder="请再次输入新密码"
                requiredMessage="请再次输入新密码"
                onAction={this.handleKeyPress}
                onChange={this.handleInput} />}
            </FieldSet>
            {errorMessage ? <Label html={errorMessage} style={{ color: 'red' }} /> : <Spacer height="20" />}
            <Spacer height="20" />
            <Button
              ui={setSuccess ? "confirm" : "action raised"}
              iconCls={submitting && "x-fa fa-spinner fa-pulse" || setSuccess && "x-fa fa-arrow-left" || ""}
              text={setSuccess ? "返回" : "重置"}
              width='100%'
              disabled={errorMessage}
              handler={setSuccess ? this.handleBack : this.handleSubmit}
            />
            <Spacer height="20" />
            <Supplier />
            <Spacer height="20" />
          </FormPanel>
        </Container>
      </Panel >)
  }
}

export default compose(
  connect(null, { doCheckToken, doSetPassword }),
)(SetPassword)



